// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Container ────────────────────────────────────────────────── */
.cal-widget {
  background: var(--surface-strong);
  border: 1px solid var(--border);
  border-radius: 12px;
  overflow: hidden;
  width: 100%;
}

/* ── Header ───────────────────────────────────────────────────── */
.cal-widget-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px 10px;
  border-bottom: 1px solid var(--border);
}

.cal-widget-title {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  font-size: 0.85rem;
  color: var(--text);
}

.cal-expand-btn {
  background: none;
  border: none;
  padding: 4px 8px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.78rem;
  color: var(--secondary-color, #4f46e5);
  font-weight: 500;
  transition: background 0.15s;
}

.cal-expand-btn:hover {
  background: color-mix(in srgb, var(--secondary-color, #4f46e5) 12%, transparent);
}

/* ── Empty / loading state ────────────────────────────────────── */
.cal-empty {
  padding: 16px;
  text-align: center;
  color: var(--muted);
  font-size: 0.83rem;
}

/* ── Event row (shared by preview and month list) ─────────────── */
.cal-event-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  padding: 9px 16px;
  background: none;
  border: none;
  border-bottom: 1px solid color-mix(in srgb, var(--border) 50%, transparent);
  cursor: default;
  text-align: left;
  transition: background 0.12s;
  color: var(--text);
}

.cal-event-row:last-child {
  border-bottom: none;
}

.cal-event-clickable {
  cursor: pointer;
}

.cal-event-clickable:hover {
  background: color-mix(in srgb, var(--secondary-color, #4f46e5) 8%, transparent);
}

.cal-event-registered {
  background: color-mix(in srgb, var(--secondary-color, #4f46e5) 6%, transparent);
  border-left: 3px solid var(--secondary-color, #4f46e5);
  padding-left: 13px;
}

.cal-event-registered.cal-event-clickable:hover {
  background: color-mix(in srgb, var(--secondary-color, #4f46e5) 14%, transparent);
}

/* Date column */
.cal-event-date-col {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 80px;
  flex-shrink: 0;
}

.cal-event-date {
  font-size: 0.78rem;
  font-weight: 500;
  color: var(--muted-strong);
  white-space: nowrap;
}

.cal-event-today {
  color: var(--secondary-color, #4f46e5);
  font-weight: 700;
}

.cal-event-time {
  font-size: 0.75rem;
  color: var(--muted);
}

/* Info column */
.cal-event-info-col {
  display: flex;
  flex-direction: column;
  gap: 3px;
  flex: 1 1;
  min-width: 0;
}

.cal-event-name {
  font-size: 0.83rem;
  font-weight: 500;
  color: var(--text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cal-registered-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.7rem;
  font-weight: 600;
  color: var(--secondary-color, #4f46e5);
  letter-spacing: 0.02em;
}

/* ── Preview "show more" button ───────────────────────────────── */
.cal-show-more {
  display: block;
  width: 100%;
  padding: 9px 16px;
  background: none;
  border: none;
  border-top: 1px solid color-mix(in srgb, var(--border) 50%, transparent);
  cursor: pointer;
  font-size: 0.78rem;
  color: var(--secondary-color, #4f46e5);
  font-weight: 500;
  text-align: center;
  transition: background 0.12s;
}

.cal-show-more:hover {
  background: color-mix(in srgb, var(--secondary-color, #4f46e5) 8%, transparent);
}

/* ── Expanded: month navigation ───────────────────────────────── */
.cal-month-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px 6px;
  border-bottom: 1px solid color-mix(in srgb, var(--border) 50%, transparent);
}

.cal-month-label {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text);
}

.cal-nav-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: 1px solid var(--border);
  border-radius: 6px;
  width: 28px;
  height: 28px;
  cursor: pointer;
  color: var(--muted-strong);
  transition: background 0.12s, color 0.12s;
  padding: 0;
}

.cal-nav-btn:hover:not(:disabled) {
  background: var(--surface);
  color: var(--text);
}

.cal-nav-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

/* ── Calendar grid ────────────────────────────────────────────── */
.cal-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 1px;
  padding: 10px 12px 4px;
}

.cal-grid-header {
  text-align: center;
  font-size: 0.7rem;
  font-weight: 600;
  color: var(--muted);
  padding: 2px 0 6px;
  letter-spacing: 0.04em;
}

.cal-grid-cell {
  position: relative;
  min-height: 44px;
  padding: 4px 3px 3px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.cal-grid-cell-empty {
  min-height: 0;
}

.cal-grid-has-event {
  background: color-mix(in srgb, var(--secondary-color, #4f46e5) 6%, transparent);
}

.cal-grid-today .cal-grid-day-num {
  background: var(--secondary-color, #4f46e5);
  color: #fff;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
}

.cal-grid-day-num {
  font-size: 0.75rem;
  color: var(--muted-strong);
  line-height: 1;
  min-width: 22px;
  text-align: center;
}

.cal-grid-dots {
  display: flex;
  align-items: center;
  gap: 2px;
  flex-wrap: wrap;
  justify-content: center;
}

.cal-grid-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--secondary-color, #4f46e5);
  opacity: 0.55;
  border: none;
  padding: 0;
  cursor: pointer;
  transition: opacity 0.12s, transform 0.12s;
}

.cal-grid-dot:hover {
  opacity: 1;
  transform: scale(1.3);
}

.cal-grid-dot-registered {
  opacity: 1;
  background: var(--secondary-color, #4f46e5);
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--secondary-color, #4f46e5) 30%, transparent);
}

.cal-grid-dot-overflow {
  font-size: 0.6rem;
  color: var(--muted);
  line-height: 1;
}

.cal-grid-reg-indicator {
  position: absolute;
  top: 3px;
  right: 3px;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--secondary-color, #4f46e5);
}

/* ── Month event list (below grid) ───────────────────────────── */
.cal-month-events {
  border-top: 1px solid color-mix(in srgb, var(--border) 50%, transparent);
  margin-top: 6px;
  max-height: 340px;
  overflow-y: auto;
}

/* ── Mobile tweaks ────────────────────────────────────────────── */
@media (max-width: 768px){
  .cal-widget{
    margin-top: 0em;
  }
}

@media (max-width: 480px) {
  .cal-grid {
    gap: 0;
    padding: 8px 4px 4px;
  }

  .cal-grid-cell {
    min-height: 36px;
    padding: 2px 1px 2px;
  }

  .cal-event-date-col {
    min-width: 80px;
  }

  .cal-event-name {
    font-size: 0.78rem;
  }
}

/* ── Light theme overrides ────────────────────────────────────── */
body.light-theme .cal-widget {
  background: var(--surface-strong);
  border-color: var(--border);
}

body.light-theme .cal-grid-day-num {
  color: var(--text);
}

body.light-theme .cal-event-date {
  color: var(--muted-strong);
}
`, "",{"version":3,"sources":["webpack://./src/components/CalendarWidget.css"],"names":[],"mappings":"AAAA,oEAAoE;AACpE;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,gFAAgF;AAClF;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,2EAA2E;EAC3E,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,+EAA+E;EAC/E,sDAAsD;EACtD,kBAAkB;AACpB;;AAEA;EACE,gFAAgF;AAClF;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA,oEAAoE;AACpE;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,wEAAwE;EACxE,eAAe;EACf,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,+EAA+E;AACjF;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,2EAA2E;AAC7E;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,yCAAyC;EACzC,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,2CAA2C;EAC3C,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,2CAA2C;EAC3C,aAAa;EACb,YAAY;EACZ,UAAU;EACV,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,2CAA2C;EAC3C,0FAA0F;AAC5F;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA,mEAAmE;AACnE;EACE,wEAAwE;EACxE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,oEAAoE;AACpE;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,MAAM;IACN,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,oEAAoE;AACpE;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["/* ── Container ────────────────────────────────────────────────── */\r\n.cal-widget {\r\n  background: var(--surface-strong);\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  width: 100%;\r\n}\r\n\r\n/* ── Header ───────────────────────────────────────────────────── */\r\n.cal-widget-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 12px 16px 10px;\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n\r\n.cal-widget-title {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-weight: 600;\r\n  font-size: 0.85rem;\r\n  color: var(--text);\r\n}\r\n\r\n.cal-expand-btn {\r\n  background: none;\r\n  border: none;\r\n  padding: 4px 8px;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 0.78rem;\r\n  color: var(--secondary-color, #4f46e5);\r\n  font-weight: 500;\r\n  transition: background 0.15s;\r\n}\r\n\r\n.cal-expand-btn:hover {\r\n  background: color-mix(in srgb, var(--secondary-color, #4f46e5) 12%, transparent);\r\n}\r\n\r\n/* ── Empty / loading state ────────────────────────────────────── */\r\n.cal-empty {\r\n  padding: 16px;\r\n  text-align: center;\r\n  color: var(--muted);\r\n  font-size: 0.83rem;\r\n}\r\n\r\n/* ── Event row (shared by preview and month list) ─────────────── */\r\n.cal-event-row {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 10px;\r\n  width: 100%;\r\n  padding: 9px 16px;\r\n  background: none;\r\n  border: none;\r\n  border-bottom: 1px solid color-mix(in srgb, var(--border) 50%, transparent);\r\n  cursor: default;\r\n  text-align: left;\r\n  transition: background 0.12s;\r\n  color: var(--text);\r\n}\r\n\r\n.cal-event-row:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.cal-event-clickable {\r\n  cursor: pointer;\r\n}\r\n\r\n.cal-event-clickable:hover {\r\n  background: color-mix(in srgb, var(--secondary-color, #4f46e5) 8%, transparent);\r\n}\r\n\r\n.cal-event-registered {\r\n  background: color-mix(in srgb, var(--secondary-color, #4f46e5) 6%, transparent);\r\n  border-left: 3px solid var(--secondary-color, #4f46e5);\r\n  padding-left: 13px;\r\n}\r\n\r\n.cal-event-registered.cal-event-clickable:hover {\r\n  background: color-mix(in srgb, var(--secondary-color, #4f46e5) 14%, transparent);\r\n}\r\n\r\n/* Date column */\r\n.cal-event-date-col {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1px;\r\n  min-width: 80px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.cal-event-date {\r\n  font-size: 0.78rem;\r\n  font-weight: 500;\r\n  color: var(--muted-strong);\r\n  white-space: nowrap;\r\n}\r\n\r\n.cal-event-today {\r\n  color: var(--secondary-color, #4f46e5);\r\n  font-weight: 700;\r\n}\r\n\r\n.cal-event-time {\r\n  font-size: 0.75rem;\r\n  color: var(--muted);\r\n}\r\n\r\n/* Info column */\r\n.cal-event-info-col {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 3px;\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.cal-event-name {\r\n  font-size: 0.83rem;\r\n  font-weight: 500;\r\n  color: var(--text);\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.cal-registered-pill {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  font-size: 0.7rem;\r\n  font-weight: 600;\r\n  color: var(--secondary-color, #4f46e5);\r\n  letter-spacing: 0.02em;\r\n}\r\n\r\n/* ── Preview \"show more\" button ───────────────────────────────── */\r\n.cal-show-more {\r\n  display: block;\r\n  width: 100%;\r\n  padding: 9px 16px;\r\n  background: none;\r\n  border: none;\r\n  border-top: 1px solid color-mix(in srgb, var(--border) 50%, transparent);\r\n  cursor: pointer;\r\n  font-size: 0.78rem;\r\n  color: var(--secondary-color, #4f46e5);\r\n  font-weight: 500;\r\n  text-align: center;\r\n  transition: background 0.12s;\r\n}\r\n\r\n.cal-show-more:hover {\r\n  background: color-mix(in srgb, var(--secondary-color, #4f46e5) 8%, transparent);\r\n}\r\n\r\n/* ── Expanded: month navigation ───────────────────────────────── */\r\n.cal-month-nav {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 10px 14px 6px;\r\n  border-bottom: 1px solid color-mix(in srgb, var(--border) 50%, transparent);\r\n}\r\n\r\n.cal-month-label {\r\n  font-size: 0.85rem;\r\n  font-weight: 600;\r\n  color: var(--text);\r\n}\r\n\r\n.cal-nav-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: none;\r\n  border: 1px solid var(--border);\r\n  border-radius: 6px;\r\n  width: 28px;\r\n  height: 28px;\r\n  cursor: pointer;\r\n  color: var(--muted-strong);\r\n  transition: background 0.12s, color 0.12s;\r\n  padding: 0;\r\n}\r\n\r\n.cal-nav-btn:hover:not(:disabled) {\r\n  background: var(--surface);\r\n  color: var(--text);\r\n}\r\n\r\n.cal-nav-btn:disabled {\r\n  opacity: 0.35;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* ── Calendar grid ────────────────────────────────────────────── */\r\n.cal-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(7, 1fr);\r\n  gap: 1px;\r\n  padding: 10px 12px 4px;\r\n}\r\n\r\n.cal-grid-header {\r\n  text-align: center;\r\n  font-size: 0.7rem;\r\n  font-weight: 600;\r\n  color: var(--muted);\r\n  padding: 2px 0 6px;\r\n  letter-spacing: 0.04em;\r\n}\r\n\r\n.cal-grid-cell {\r\n  position: relative;\r\n  min-height: 44px;\r\n  padding: 4px 3px 3px;\r\n  border-radius: 6px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 2px;\r\n}\r\n\r\n.cal-grid-cell-empty {\r\n  min-height: 0;\r\n}\r\n\r\n.cal-grid-has-event {\r\n  background: color-mix(in srgb, var(--secondary-color, #4f46e5) 6%, transparent);\r\n}\r\n\r\n.cal-grid-today .cal-grid-day-num {\r\n  background: var(--secondary-color, #4f46e5);\r\n  color: #fff;\r\n  border-radius: 50%;\r\n  width: 22px;\r\n  height: 22px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-weight: 700;\r\n}\r\n\r\n.cal-grid-day-num {\r\n  font-size: 0.75rem;\r\n  color: var(--muted-strong);\r\n  line-height: 1;\r\n  min-width: 22px;\r\n  text-align: center;\r\n}\r\n\r\n.cal-grid-dots {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 2px;\r\n  flex-wrap: wrap;\r\n  justify-content: center;\r\n}\r\n\r\n.cal-grid-dot {\r\n  width: 6px;\r\n  height: 6px;\r\n  border-radius: 50%;\r\n  background: var(--secondary-color, #4f46e5);\r\n  opacity: 0.55;\r\n  border: none;\r\n  padding: 0;\r\n  cursor: pointer;\r\n  transition: opacity 0.12s, transform 0.12s;\r\n}\r\n\r\n.cal-grid-dot:hover {\r\n  opacity: 1;\r\n  transform: scale(1.3);\r\n}\r\n\r\n.cal-grid-dot-registered {\r\n  opacity: 1;\r\n  background: var(--secondary-color, #4f46e5);\r\n  box-shadow: 0 0 0 2px color-mix(in srgb, var(--secondary-color, #4f46e5) 30%, transparent);\r\n}\r\n\r\n.cal-grid-dot-overflow {\r\n  font-size: 0.6rem;\r\n  color: var(--muted);\r\n  line-height: 1;\r\n}\r\n\r\n.cal-grid-reg-indicator {\r\n  position: absolute;\r\n  top: 3px;\r\n  right: 3px;\r\n  width: 5px;\r\n  height: 5px;\r\n  border-radius: 50%;\r\n  background: var(--secondary-color, #4f46e5);\r\n}\r\n\r\n/* ── Month event list (below grid) ───────────────────────────── */\r\n.cal-month-events {\r\n  border-top: 1px solid color-mix(in srgb, var(--border) 50%, transparent);\r\n  margin-top: 6px;\r\n  max-height: 340px;\r\n  overflow-y: auto;\r\n}\r\n\r\n/* ── Mobile tweaks ────────────────────────────────────────────── */\r\n@media (max-width: 768px){\r\n  .cal-widget{\r\n    margin-top: 0em;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .cal-grid {\r\n    gap: 0;\r\n    padding: 8px 4px 4px;\r\n  }\r\n\r\n  .cal-grid-cell {\r\n    min-height: 36px;\r\n    padding: 2px 1px 2px;\r\n  }\r\n\r\n  .cal-event-date-col {\r\n    min-width: 80px;\r\n  }\r\n\r\n  .cal-event-name {\r\n    font-size: 0.78rem;\r\n  }\r\n}\r\n\r\n/* ── Light theme overrides ────────────────────────────────────── */\r\nbody.light-theme .cal-widget {\r\n  background: var(--surface-strong);\r\n  border-color: var(--border);\r\n}\r\n\r\nbody.light-theme .cal-grid-day-num {\r\n  color: var(--text);\r\n}\r\n\r\nbody.light-theme .cal-event-date {\r\n  color: var(--muted-strong);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
